<!--
 * @Description: 
 * @Author: zhanglu
 * @Date: 2020-12-01 16:33:43
 * @LastEditors: zhanglu
 * @LastEditTime: 2020-12-01 17:22:25
-->
<template>
  <add-or-update pageType="add" />
</template>

<script>
// components
import addOrUpdate from "./components/addOrUpdate";

export default {
  name: "customerAdd",
  components: { addOrUpdate }
};
</script>
